import type { AppState } from '@/types';

export const selectChangelog = (state: AppState) => state.changelog;
